module.exports = __webpack_public_path__ + "static/media/light_icn_map_fermata_lex.82cb2410.svg";